import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { HashRouter } from 'react-router-dom';

if (
  import.meta.env.DEV &&
  typeof window !== 'undefined' &&
  window.navigator?.serviceWorker
) {
  window.navigator.serviceWorker.getRegistrations().then((registrations) => {
    registrations.forEach((registration) => registration.unregister());
  });
}
import './i18n';
import './styles/globals.css';
import { App } from './App';

createRoot(document.getElementById('root')).render(
  <StrictMode>
    <HashRouter>
      <App />
    </HashRouter>
  </StrictMode>
);
